import cx from 'classnames'

import { CINEMA_TYPE } from '../../pages/Hall/constants'
import { PAGE_NAME } from '../OrderStepsHeader/constants'

import './CinemaTypeImg.scss'

const CinemaTypeImg = ({ cinemaType = CINEMA_TYPE.DEFAULT, page, imgUrl, imgAlt }) => {
    return (
        <>
            <div className={cx(`cinema-img position-absolute w-100 top-0 start-0 end-0 ${!imgUrl && 'd-none'}`)}>
                <img src={imgUrl} alt={imgAlt} className={`${cinemaType} w-100`} loading={'lazy'} />
            </div>
            {page === PAGE_NAME.hall && cinemaType !== CINEMA_TYPE.DEFAULT && (
                <div className={'cinema-type position-absolute w-100 top-0 start-0 end-0'}>
                    {cinemaType === CINEMA_TYPE.DELUXE && (
                        <img src={'images/hall/deluxe.png'} alt={'Deluxe'} className={'w-100 mt-5'} />
                    )}
                    {cinemaType === CINEMA_TYPE.GOLD_CLASS && (
                        <img src={'images/hall/gold-class.png'} alt={'Gold Class'} className={'w-100'} />
                    )}
                    {cinemaType === CINEMA_TYPE.BOUTIQUE && (
                        <img src={'images/hall/boutique-cinema.png'} alt={'Premium'} className={'w-100'} />
                    )}
                </div>
            )}
        </>
    )
}

export default CinemaTypeImg
